// extracted by mini-css-extract-plugin
module.exports = {"item":"footer_item-module--item--1tFrz","title":"footer_item-module--title--1qWzv","description":"footer_item-module--description--ggspR","icon":"footer_item-module--icon--35xpd"};